import React from "react";

import { useNavigate } from "react-router-dom";

import { Typography, Button } from "clearsense-ui/components";
import NoPermission from "images/noPermission.svg";

import { Home } from "./clearsense-ui/icons";

const NoPermissionPage = ({ homeRoute }) => {
  const nagivate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center flex-1 w-full h-screen">
      <NoPermission />
      <Typography style="h3" className="mb-3 mt-2.5 font-semibold">
        You don’t have permission to view this page!
      </Typography>
      <Typography className="max-w-sm text-center">
        Seems like you’ve stumbled onto a page you can't view due to your role
        and its permissions.
      </Typography>
      <Typography className="max-w-sm mb-6 text-center">
        If you think that's wrong, please contact the admin!
      </Typography>
      {homeRoute && (
        <Button
          style="secondary"
          label="Go to Home"
          onClick={() => nagivate(homeRoute)}
          icon={Home}
        />
      )}
    </div>
  );
};

export default NoPermissionPage;
